import * as i18next from 'i18next';

import { Settings } from './Settings';
import { Dict } from '../utils/Types';
import { buildQueryString, stripHash, parseQueryString, stripQueryString } from '../utils/Url';
import { getEnvVar } from '../utils/ReactScriptHelper';

import utils = egr.wcf.utils;

const PCON_LOGIN_BASEURL: string = getEnvVar('PCON_LOGIN_URL', 'https://login.pcon-solutions.com/');
const OAUTH_BACKGROUND_CALLBACK_URL: string = ((): string => {
    const path: string = document.location.pathname.substr(0, document.location.pathname.lastIndexOf('/'));

    return document.location.protocol + '//' + document.location.host + path + '/oauth_callback.html';
})();

const pconLoginUrlFraments: Array<string> = ['access_token', 'expires_in', 'token_type', 'scope', 'state'];

export class SettingProvider implements Settings {
    public constructor(protected clientId: string, protected i18n?: i18next.I18n) {
    }

    public get profileUrl(): string {
        return PCON_LOGIN_BASEURL;
    }

    public get authApiUrl(): string {
        const hash: string = document.location.hash.slice(1);
        if (utils.string.isNotNullOrEmpty(hash)) {
            // The hash part should be used for debug purpose only!
            // However, it won't work with pCon.login -> we have to use a little hack.

            // Delete pCon.login related parameters
            const hashQuery: Dict = parseQueryString(hash);
            for (const key of pconLoginUrlFraments) {
                delete hashQuery[key];
            }

            const query: Dict = parseQueryString(document.location.search.slice(1));
            query.fragment = buildQueryString(hashQuery);

            let baseUrl: string = stripHash(stripQueryString(document.location.href));
            if (!baseUrl.endsWith('/')) {
                baseUrl = baseUrl.substr(0, baseUrl.lastIndexOf('/') + 1);
            }

            return this.buildAuthApiUrl(baseUrl  + 'pcon_login_hash_fix.html?' + buildQueryString(query));
        }

        return this.buildAuthApiUrl();
    }

    public get iframeAuthApiUrl(): string {
        return this.buildAuthApiUrl(OAUTH_BACKGROUND_CALLBACK_URL);
    }

    public get backgroundAuthApiUrl(): string {
        return this.buildAuthApiUrl(
            OAUTH_BACKGROUND_CALLBACK_URL,
            {
                no_login: 1
            }
        );
    }

    public get userApiUrl(): string {
        return PCON_LOGIN_BASEURL + 'api/v1/account/user?embed=account_organization';
    }

    public get logoutApiUrl(): string {
        return PCON_LOGIN_BASEURL + 'api/v1/logout';
    }

    public get organizationApiUrl(): string {
        return PCON_LOGIN_BASEURL + 'api/v1/account/organization';
    }

    protected buildAuthApiUrl(url: string = document.location.href, additionalArguments?: Dict<{}>): string {
        const userLanguage: string | undefined = this.getUserLanguage();
        return PCON_LOGIN_BASEURL + 'api/oauth2/authorize?' + buildQueryString(
            Object.assign(
                {
                    lang: utils.string.isNotNullOrEmpty(userLanguage) ? userLanguage : 'en',
                    client_id: this.clientId,
                    response_type: 'token',
                    redirect_uri: stripHash(url),
                    state: '123456' // FixMe: use real state
                },
                additionalArguments
            )
        );
    }

    protected getUserLanguage(): string | undefined {
        if (
            this.i18n == null ||
            utils.string.isNullOrEmpty(this.i18n.language) ||
            utils.string.isNullOrEmpty(this.i18n.language.split('-')[0])
        ) {
            return;
        }

        return this.i18n.language.split('-')[0];
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/submodules/pcon-login-api/SettingsProvider.ts